import {createFeatureSelector, createSelector} from '@ngrx/store';
import {IMailerServiceProviderState} from '@app/stores/mailer-service-provider/mailer-service-provider.state';

const selectMailerServiceProvider = createFeatureSelector<IMailerServiceProviderState>('mailerServiceProviders');

export const getMailerServiceProviderSuccess = createSelector(selectMailerServiceProvider, (state: IMailerServiceProviderState) => state.success);

export const getMailerServiceProviderError = createSelector(selectMailerServiceProvider, (state: IMailerServiceProviderState) => state.error);

export const getPaginatedMailerServiceProviders = createSelector(selectMailerServiceProvider, (state: IMailerServiceProviderState) => state.paginatedMailerServiceProviders);
